<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import DocsNavBar from "./components/DocsNavBar.vue";

const store = useStore();
const windowWidth = ref(window.innerWidth);

// Detectar cambios de tamaño
const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  document.body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateWindowWidth);
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  document.body.classList.add("bg-gray-100");
});

</script>

<template>
  <div class="container-fluid vh-100">
    <div class="row h-100">
      <!-- Navbar lateral -->
      <div class="col-12 col-md-2">
        <DocsNavBar />
      </div>
      <!-- Contenido principal -->
      <main class="col-12 col-md-10 overflow-auto p-7">

        <!-- Sección del manual de usuario (Registro de Eventos) -->
        <hr>
        <h3> Manual de Usuario - Registro de Eventos <br> <img src="../../assets/img/user-manual/UserManual-3.gif" alt=""> </h3>
        <section class="mt-4">
          <hr>
          <p class="text-gray-700">
            <u><b>  Última Revisión:</b></u> 27/03/2025 <br><br>
            Bienvenid@ a esta breve guía que le ayudará a conocer el proceso de registro para actividades y/o eventos dentro de esta nueva plataforma.<br>
          </p>

          <div class="mt-4">
            <h4 class="text-xl font-semibold"> <i class="bi bi-caret-right-fill"></i> Registro de Eventos.</h4>
          </div>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 1 - Accede al panel principal</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualEvents-1.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez que haya ingresado correctamente, verá el siguiente panel de control, donde podrá realizar diferentes actividades</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 2 - Accede al calendario de registro</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualEvents-2.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">En la sección denominada <b>"Registrar Tiempo <i class="bi bi-arrow-right"></i> Registrar Agenda"</b> podrá registrar eventos y/o actividades dentro del calendario.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 3 - Formulario de registro</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualEvents-3.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez hayas hecho clic en el boton de  <b>"Registrar evento"</b>, podrá observar un formulario de registro como el siguiente. </p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 4 - Formato de registro</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualEvents-4.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Dentro del formulario tendrá que rellenar todos los campos que se muestran a continuación, a excepción del campo "Notas", en este podrá describir detalles específicos de ser necesario.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 5 - Verificar evento registrado</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualEvents-5.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">Una vez que haya enviado el formulario de registro, puede volver al calendario para comprobar y verificar que este se haya registrado de forma correcta.</p>
            </div>
          </div><br>

          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-center"> <i class="bi bi-caret-right"></i> PASO 6 - Opciones adicionales</h5>
            </div>
            <img src="../../assets/img/user-manual/UserManualEvents-6.png" class="card-img-bottom" alt="...">
            <div class="card-body">
              <p class="card-text">En caso de que hayas introducido mal los datos de un evento o simplemente no quieras cancelarlo, puedes modificarlo o simplemente borrarlo haciendo clic a la derecha del nombre del evento, como se muestra en la imagen.</p>
            </div>
          </div><br>
        </section>
        <!-- Final - Sección del manual de usuario (Registro de Eventos) -->

      </main>
    </div>
  </div>
</template>

<style scoped>
  /* Estilos adicionales para asegurar que todo se vea bien */
  main {
    min-height: 100vh; /* Asegurar que el contenido tenga la altura completa */
  }

 h3 {
   text-align: center;
 }
 .bi-caret-right-fill {
  color: #db7535;
 }

 .bi-caret-right {
  color: #db7535;
 }

 .card {
  background: #f5f2f2 ;
 }

</style>
